import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import StepCSSTransitionGroup from '../Animations/StepCSSTransitionGroup.js';
import styles from './Page.module.scss.js';

var Page = (function (_super) {
    __extends(Page, _super);
    function Page() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Page.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: classNames(styles.wrapper, this.props.className) },
            React.createElement(StepCSSTransitionGroup, { level: this.props.startAnimationIndex },
                React.createElement("h1", { className: styles.header }, this.props.rules.title)),
            this.props.rules.items.map(function (item, i) {
                return (React.createElement(StepCSSTransitionGroup, { level: _this.props.startAnimationIndex + i, key: "Item" + i },
                    React.createElement("div", { className: styles.item },
                        React.createElement("div", { className: "" + styles.image },
                            React.createElement("div", { className: styles.icon + " " + (item.image ? styles[item.image] : '') })),
                        React.createElement("div", { className: styles.content },
                            React.createElement("span", { className: styles.title }, "" + item.title),
                            React.createElement("ul", { className: styles.description }, item.descr.map(function (descrItem, j) {
                                return React.createElement("li", { key: "Row" + j }, "" + descrItem);
                            }))))));
            })));
    };
    return Page;
}(React.PureComponent));

export { Page as default };
//# sourceMappingURL=Page.js.map
